module.exports = __webpack_public_path__ + "img/Logo_PEAKBoard.c5d1966a.png";